module.exports = __webpack_public_path__ + "05bd6cc4cbab924f83121b873b02dd86.svg";